/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Spinner } from "reactstrap";

const LoadingSpinner = () => (
  <div className="flex-dynamic d-flex justify-content-center align-items-center">
    <Spinner color="success" style={{ width: '3rem', height: '3rem' }} />
  </div>
);

export default LoadingSpinner;
